(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j4NmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de34aeb5c04427ee$export$2e2bcd8739ae039; });
// packages/alpinejs/src/scheduler.js
var $de34aeb5c04427ee$var$flushPending = false;
var $de34aeb5c04427ee$var$flushing = false;
var $de34aeb5c04427ee$var$queue = [];
var $de34aeb5c04427ee$var$lastFlushedIndex = -1;
function $de34aeb5c04427ee$var$scheduler(callback) {
    $de34aeb5c04427ee$var$queueJob(callback);
}
function $de34aeb5c04427ee$var$queueJob(job) {
    if (!$de34aeb5c04427ee$var$queue.includes(job)) $de34aeb5c04427ee$var$queue.push(job);
    $de34aeb5c04427ee$var$queueFlush();
}
function $de34aeb5c04427ee$var$dequeueJob(job) {
    let index = $de34aeb5c04427ee$var$queue.indexOf(job);
    if (index !== -1 && index > $de34aeb5c04427ee$var$lastFlushedIndex) $de34aeb5c04427ee$var$queue.splice(index, 1);
}
function $de34aeb5c04427ee$var$queueFlush() {
    if (!$de34aeb5c04427ee$var$flushing && !$de34aeb5c04427ee$var$flushPending) {
        $de34aeb5c04427ee$var$flushPending = true;
        queueMicrotask($de34aeb5c04427ee$var$flushJobs);
    }
}
function $de34aeb5c04427ee$var$flushJobs() {
    $de34aeb5c04427ee$var$flushPending = false;
    $de34aeb5c04427ee$var$flushing = true;
    for(let i = 0; i < $de34aeb5c04427ee$var$queue.length; i++){
        $de34aeb5c04427ee$var$queue[i]();
        $de34aeb5c04427ee$var$lastFlushedIndex = i;
    }
    $de34aeb5c04427ee$var$queue.length = 0;
    $de34aeb5c04427ee$var$lastFlushedIndex = -1;
    $de34aeb5c04427ee$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $de34aeb5c04427ee$var$reactive;
var $de34aeb5c04427ee$var$effect;
var $de34aeb5c04427ee$var$release;
var $de34aeb5c04427ee$var$raw;
var $de34aeb5c04427ee$var$shouldSchedule = true;
function $de34aeb5c04427ee$var$disableEffectScheduling(callback) {
    $de34aeb5c04427ee$var$shouldSchedule = false;
    callback();
    $de34aeb5c04427ee$var$shouldSchedule = true;
}
function $de34aeb5c04427ee$var$setReactivityEngine(engine) {
    $de34aeb5c04427ee$var$reactive = engine.reactive;
    $de34aeb5c04427ee$var$release = engine.release;
    $de34aeb5c04427ee$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($de34aeb5c04427ee$var$shouldSchedule) $de34aeb5c04427ee$var$scheduler(task);
                else task();
            }
        });
    $de34aeb5c04427ee$var$raw = engine.raw;
}
function $de34aeb5c04427ee$var$overrideEffect(override) {
    $de34aeb5c04427ee$var$effect = override;
}
function $de34aeb5c04427ee$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $de34aeb5c04427ee$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $de34aeb5c04427ee$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $de34aeb5c04427ee$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $de34aeb5c04427ee$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$de34aeb5c04427ee$var$release(effectReference);
}
// packages/alpinejs/src/utils/dispatch.js
function $de34aeb5c04427ee$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $de34aeb5c04427ee$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$de34aeb5c04427ee$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $de34aeb5c04427ee$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $de34aeb5c04427ee$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $de34aeb5c04427ee$var$started = false;
function $de34aeb5c04427ee$var$start() {
    if ($de34aeb5c04427ee$var$started) $de34aeb5c04427ee$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $de34aeb5c04427ee$var$started = true;
    if (!document.body) $de34aeb5c04427ee$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $de34aeb5c04427ee$var$dispatch(document, "alpine:init");
    $de34aeb5c04427ee$var$dispatch(document, "alpine:initializing");
    $de34aeb5c04427ee$var$startObservingMutations();
    $de34aeb5c04427ee$var$onElAdded((el)=>$de34aeb5c04427ee$var$initTree(el, $de34aeb5c04427ee$var$walk));
    $de34aeb5c04427ee$var$onElRemoved((el)=>$de34aeb5c04427ee$var$destroyTree(el));
    $de34aeb5c04427ee$var$onAttributesAdded((el, attrs)=>{
        $de34aeb5c04427ee$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$de34aeb5c04427ee$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($de34aeb5c04427ee$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $de34aeb5c04427ee$var$initTree(el);
    });
    $de34aeb5c04427ee$var$dispatch(document, "alpine:initialized");
}
var $de34aeb5c04427ee$var$rootSelectorCallbacks = [];
var $de34aeb5c04427ee$var$initSelectorCallbacks = [];
function $de34aeb5c04427ee$var$rootSelectors() {
    return $de34aeb5c04427ee$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $de34aeb5c04427ee$var$allSelectors() {
    return $de34aeb5c04427ee$var$rootSelectorCallbacks.concat($de34aeb5c04427ee$var$initSelectorCallbacks).map((fn)=>fn());
}
function $de34aeb5c04427ee$var$addRootSelector(selectorCallback) {
    $de34aeb5c04427ee$var$rootSelectorCallbacks.push(selectorCallback);
}
function $de34aeb5c04427ee$var$addInitSelector(selectorCallback) {
    $de34aeb5c04427ee$var$initSelectorCallbacks.push(selectorCallback);
}
function $de34aeb5c04427ee$var$closestRoot(el, includeInitSelectors = false) {
    return $de34aeb5c04427ee$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $de34aeb5c04427ee$var$allSelectors() : $de34aeb5c04427ee$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $de34aeb5c04427ee$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $de34aeb5c04427ee$var$findClosest(el.parentElement, callback);
}
function $de34aeb5c04427ee$var$isRoot(el) {
    return $de34aeb5c04427ee$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $de34aeb5c04427ee$var$initInterceptors = [];
function $de34aeb5c04427ee$var$interceptInit(callback) {
    $de34aeb5c04427ee$var$initInterceptors.push(callback);
}
function $de34aeb5c04427ee$var$initTree(el, walker = $de34aeb5c04427ee$var$walk, intercept = ()=>{}) {
    $de34aeb5c04427ee$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $de34aeb5c04427ee$var$initInterceptors.forEach((i)=>i(el2, skip));
            $de34aeb5c04427ee$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $de34aeb5c04427ee$var$destroyTree(root) {
    $de34aeb5c04427ee$var$walk(root, (el)=>{
        $de34aeb5c04427ee$var$cleanupAttributes(el);
        $de34aeb5c04427ee$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $de34aeb5c04427ee$var$onAttributeAddeds = [];
var $de34aeb5c04427ee$var$onElRemoveds = [];
var $de34aeb5c04427ee$var$onElAddeds = [];
function $de34aeb5c04427ee$var$onElAdded(callback) {
    $de34aeb5c04427ee$var$onElAddeds.push(callback);
}
function $de34aeb5c04427ee$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $de34aeb5c04427ee$var$onElRemoveds.push(callback);
    }
}
function $de34aeb5c04427ee$var$onAttributesAdded(callback) {
    $de34aeb5c04427ee$var$onAttributeAddeds.push(callback);
}
function $de34aeb5c04427ee$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $de34aeb5c04427ee$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $de34aeb5c04427ee$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $de34aeb5c04427ee$var$observer = new MutationObserver($de34aeb5c04427ee$var$onMutate);
var $de34aeb5c04427ee$var$currentlyObserving = false;
function $de34aeb5c04427ee$var$startObservingMutations() {
    $de34aeb5c04427ee$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $de34aeb5c04427ee$var$currentlyObserving = true;
}
function $de34aeb5c04427ee$var$stopObservingMutations() {
    $de34aeb5c04427ee$var$flushObserver();
    $de34aeb5c04427ee$var$observer.disconnect();
    $de34aeb5c04427ee$var$currentlyObserving = false;
}
var $de34aeb5c04427ee$var$queuedMutations = [];
function $de34aeb5c04427ee$var$flushObserver() {
    let records = $de34aeb5c04427ee$var$observer.takeRecords();
    $de34aeb5c04427ee$var$queuedMutations.push(()=>records.length > 0 && $de34aeb5c04427ee$var$onMutate(records));
    let queueLengthWhenTriggered = $de34aeb5c04427ee$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($de34aeb5c04427ee$var$queuedMutations.length === queueLengthWhenTriggered) while($de34aeb5c04427ee$var$queuedMutations.length > 0)$de34aeb5c04427ee$var$queuedMutations.shift()();
    });
}
function $de34aeb5c04427ee$var$mutateDom(callback) {
    if (!$de34aeb5c04427ee$var$currentlyObserving) return callback();
    $de34aeb5c04427ee$var$stopObservingMutations();
    let result = callback();
    $de34aeb5c04427ee$var$startObservingMutations();
    return result;
}
var $de34aeb5c04427ee$var$isCollecting = false;
var $de34aeb5c04427ee$var$deferredMutations = [];
function $de34aeb5c04427ee$var$deferMutations() {
    $de34aeb5c04427ee$var$isCollecting = true;
}
function $de34aeb5c04427ee$var$flushAndStopDeferringMutations() {
    $de34aeb5c04427ee$var$isCollecting = false;
    $de34aeb5c04427ee$var$onMutate($de34aeb5c04427ee$var$deferredMutations);
    $de34aeb5c04427ee$var$deferredMutations = [];
}
function $de34aeb5c04427ee$var$onMutate(mutations) {
    if ($de34aeb5c04427ee$var$isCollecting) {
        $de34aeb5c04427ee$var$deferredMutations = $de34aeb5c04427ee$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $de34aeb5c04427ee$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $de34aeb5c04427ee$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $de34aeb5c04427ee$var$onElRemoveds.forEach((i)=>i(node));
        $de34aeb5c04427ee$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $de34aeb5c04427ee$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $de34aeb5c04427ee$var$scope(node) {
    return $de34aeb5c04427ee$var$mergeProxies($de34aeb5c04427ee$var$closestDataStack(node));
}
function $de34aeb5c04427ee$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$de34aeb5c04427ee$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $de34aeb5c04427ee$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $de34aeb5c04427ee$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $de34aeb5c04427ee$var$closestDataStack(node.parentNode);
}
function $de34aeb5c04427ee$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $de34aeb5c04427ee$var$mergeProxyTrap);
}
var $de34aeb5c04427ee$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $de34aeb5c04427ee$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $de34aeb5c04427ee$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $de34aeb5c04427ee$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $de34aeb5c04427ee$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$de34aeb5c04427ee$var$get(data2, path), (value)=>$de34aeb5c04427ee$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $de34aeb5c04427ee$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $de34aeb5c04427ee$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $de34aeb5c04427ee$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $de34aeb5c04427ee$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $de34aeb5c04427ee$var$magics = {};
function $de34aeb5c04427ee$var$magic(name, callback) {
    $de34aeb5c04427ee$var$magics[name] = callback;
}
function $de34aeb5c04427ee$var$injectMagics(obj, el) {
    Object.entries($de34aeb5c04427ee$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $de34aeb5c04427ee$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $de34aeb5c04427ee$var$interceptor,
                    ...utilities
                };
                $de34aeb5c04427ee$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $de34aeb5c04427ee$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $de34aeb5c04427ee$var$handleError(e, el, expression);
    }
}
function $de34aeb5c04427ee$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $de34aeb5c04427ee$var$shouldAutoEvaluateFunctions = true;
function $de34aeb5c04427ee$var$dontAutoEvaluateFunctions(callback) {
    let cache = $de34aeb5c04427ee$var$shouldAutoEvaluateFunctions;
    $de34aeb5c04427ee$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $de34aeb5c04427ee$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $de34aeb5c04427ee$var$evaluate(el, expression, extras = {}) {
    let result;
    $de34aeb5c04427ee$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $de34aeb5c04427ee$var$evaluateLater(...args) {
    return $de34aeb5c04427ee$var$theEvaluatorFunction(...args);
}
var $de34aeb5c04427ee$var$theEvaluatorFunction = $de34aeb5c04427ee$var$normalEvaluator;
function $de34aeb5c04427ee$var$setEvaluator(newEvaluator) {
    $de34aeb5c04427ee$var$theEvaluatorFunction = newEvaluator;
}
function $de34aeb5c04427ee$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $de34aeb5c04427ee$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$de34aeb5c04427ee$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $de34aeb5c04427ee$var$generateEvaluatorFromFunction(dataStack, expression) : $de34aeb5c04427ee$var$generateEvaluatorFromString(dataStack, expression, el);
    return $de34aeb5c04427ee$var$tryCatch.bind(null, el, expression, evaluator);
}
function $de34aeb5c04427ee$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($de34aeb5c04427ee$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $de34aeb5c04427ee$var$runIfTypeOfFunction(receiver, result);
    };
}
var $de34aeb5c04427ee$var$evaluatorMemo = {};
function $de34aeb5c04427ee$var$generateFunctionFromString(expression, el) {
    if ($de34aeb5c04427ee$var$evaluatorMemo[expression]) return $de34aeb5c04427ee$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $de34aeb5c04427ee$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $de34aeb5c04427ee$var$evaluatorMemo[expression] = func;
    return func;
}
function $de34aeb5c04427ee$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $de34aeb5c04427ee$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $de34aeb5c04427ee$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$de34aeb5c04427ee$var$handleError(error2, el, expression));
            if (func.finished) {
                $de34aeb5c04427ee$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $de34aeb5c04427ee$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$de34aeb5c04427ee$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $de34aeb5c04427ee$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($de34aeb5c04427ee$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$de34aeb5c04427ee$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$de34aeb5c04427ee$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $de34aeb5c04427ee$var$prefixAsString = "x-";
function $de34aeb5c04427ee$var$prefix(subject = "") {
    return $de34aeb5c04427ee$var$prefixAsString + subject;
}
function $de34aeb5c04427ee$var$setPrefix(newPrefix) {
    $de34aeb5c04427ee$var$prefixAsString = newPrefix;
}
var $de34aeb5c04427ee$var$directiveHandlers = {};
function $de34aeb5c04427ee$var$directive(name, callback) {
    $de34aeb5c04427ee$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$de34aeb5c04427ee$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $de34aeb5c04427ee$var$directiveOrder.indexOf(directive2);
            $de34aeb5c04427ee$var$directiveOrder.splice(pos >= 0 ? pos : $de34aeb5c04427ee$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $de34aeb5c04427ee$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $de34aeb5c04427ee$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($de34aeb5c04427ee$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($de34aeb5c04427ee$var$outNonAlpineAttributes).map($de34aeb5c04427ee$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($de34aeb5c04427ee$var$byPriority);
    return directives2.map((directive2)=>{
        return $de34aeb5c04427ee$var$getDirectiveHandler(el, directive2);
    });
}
function $de34aeb5c04427ee$var$attributesOnly(attributes) {
    return Array.from(attributes).map($de34aeb5c04427ee$var$toTransformedAttributes()).filter((attr)=>!$de34aeb5c04427ee$var$outNonAlpineAttributes(attr));
}
var $de34aeb5c04427ee$var$isDeferringHandlers = false;
var $de34aeb5c04427ee$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $de34aeb5c04427ee$var$currentHandlerStackKey = Symbol();
function $de34aeb5c04427ee$var$deferHandlingDirectives(callback) {
    $de34aeb5c04427ee$var$isDeferringHandlers = true;
    let key = Symbol();
    $de34aeb5c04427ee$var$currentHandlerStackKey = key;
    $de34aeb5c04427ee$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($de34aeb5c04427ee$var$directiveHandlerStacks.get(key).length)$de34aeb5c04427ee$var$directiveHandlerStacks.get(key).shift()();
        $de34aeb5c04427ee$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $de34aeb5c04427ee$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $de34aeb5c04427ee$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $de34aeb5c04427ee$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $de34aeb5c04427ee$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $de34aeb5c04427ee$var$evaluateLater.bind($de34aeb5c04427ee$var$evaluateLater, el),
        evaluate: $de34aeb5c04427ee$var$evaluate.bind($de34aeb5c04427ee$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $de34aeb5c04427ee$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $de34aeb5c04427ee$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $de34aeb5c04427ee$var$getElementBoundUtilities(el);
    $de34aeb5c04427ee$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $de34aeb5c04427ee$var$isDeferringHandlers ? $de34aeb5c04427ee$var$directiveHandlerStacks.get($de34aeb5c04427ee$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $de34aeb5c04427ee$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $de34aeb5c04427ee$var$into = (i)=>i;
function $de34aeb5c04427ee$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $de34aeb5c04427ee$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $de34aeb5c04427ee$var$attributeTransformers = [];
function $de34aeb5c04427ee$var$mapAttributes(callback) {
    $de34aeb5c04427ee$var$attributeTransformers.push(callback);
}
function $de34aeb5c04427ee$var$outNonAlpineAttributes({ name: name }) {
    return $de34aeb5c04427ee$var$alpineAttributeRegex().test(name);
}
var $de34aeb5c04427ee$var$alpineAttributeRegex = ()=>new RegExp(`^${$de34aeb5c04427ee$var$prefixAsString}([^:^.]+)\\b`);
function $de34aeb5c04427ee$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($de34aeb5c04427ee$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $de34aeb5c04427ee$var$DEFAULT = "DEFAULT";
var $de34aeb5c04427ee$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $de34aeb5c04427ee$var$DEFAULT,
    "teleport"
];
function $de34aeb5c04427ee$var$byPriority(a, b) {
    let typeA = $de34aeb5c04427ee$var$directiveOrder.indexOf(a.type) === -1 ? $de34aeb5c04427ee$var$DEFAULT : a.type;
    let typeB = $de34aeb5c04427ee$var$directiveOrder.indexOf(b.type) === -1 ? $de34aeb5c04427ee$var$DEFAULT : b.type;
    return $de34aeb5c04427ee$var$directiveOrder.indexOf(typeA) - $de34aeb5c04427ee$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $de34aeb5c04427ee$var$tickStack = [];
var $de34aeb5c04427ee$var$isHolding = false;
function $de34aeb5c04427ee$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $de34aeb5c04427ee$var$isHolding || setTimeout(()=>{
            $de34aeb5c04427ee$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $de34aeb5c04427ee$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $de34aeb5c04427ee$var$releaseNextTicks() {
    $de34aeb5c04427ee$var$isHolding = false;
    while($de34aeb5c04427ee$var$tickStack.length)$de34aeb5c04427ee$var$tickStack.shift()();
}
function $de34aeb5c04427ee$var$holdNextTicks() {
    $de34aeb5c04427ee$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $de34aeb5c04427ee$var$setClasses(el, value) {
    if (Array.isArray(value)) return $de34aeb5c04427ee$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $de34aeb5c04427ee$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $de34aeb5c04427ee$var$setClasses(el, value());
    return $de34aeb5c04427ee$var$setClassesFromString(el, value);
}
function $de34aeb5c04427ee$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $de34aeb5c04427ee$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $de34aeb5c04427ee$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $de34aeb5c04427ee$var$setStylesFromObject(el, value);
    return $de34aeb5c04427ee$var$setStylesFromString(el, value);
}
function $de34aeb5c04427ee$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $de34aeb5c04427ee$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $de34aeb5c04427ee$var$setStyles(el, previousStyles);
    };
}
function $de34aeb5c04427ee$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $de34aeb5c04427ee$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $de34aeb5c04427ee$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$de34aeb5c04427ee$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $de34aeb5c04427ee$var$registerTransitionsFromHelper(el, modifiers, value);
    else $de34aeb5c04427ee$var$registerTransitionsFromClassString(el, expression, value);
});
function $de34aeb5c04427ee$var$registerTransitionsFromClassString(el, classString, stage) {
    $de34aeb5c04427ee$var$registerTransitionObject(el, $de34aeb5c04427ee$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $de34aeb5c04427ee$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $de34aeb5c04427ee$var$registerTransitionObject(el, $de34aeb5c04427ee$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $de34aeb5c04427ee$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $de34aeb5c04427ee$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $de34aeb5c04427ee$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $de34aeb5c04427ee$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $de34aeb5c04427ee$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $de34aeb5c04427ee$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $de34aeb5c04427ee$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $de34aeb5c04427ee$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $de34aeb5c04427ee$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $de34aeb5c04427ee$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $de34aeb5c04427ee$var$closestHide(parent);
}
function $de34aeb5c04427ee$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $de34aeb5c04427ee$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $de34aeb5c04427ee$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $de34aeb5c04427ee$var$once(()=>{
        $de34aeb5c04427ee$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $de34aeb5c04427ee$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $de34aeb5c04427ee$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $de34aeb5c04427ee$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $de34aeb5c04427ee$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $de34aeb5c04427ee$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $de34aeb5c04427ee$var$mutateDom(()=>{
                stages.end();
            });
            $de34aeb5c04427ee$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $de34aeb5c04427ee$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $de34aeb5c04427ee$var$isCloning = false;
function $de34aeb5c04427ee$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$de34aeb5c04427ee$var$isCloning ? fallback(...args) : callback(...args);
}
function $de34aeb5c04427ee$var$onlyDuringClone(callback) {
    return (...args)=>$de34aeb5c04427ee$var$isCloning && callback(...args);
}
var $de34aeb5c04427ee$var$interceptors = [];
function $de34aeb5c04427ee$var$interceptClone(callback) {
    $de34aeb5c04427ee$var$interceptors.push(callback);
}
function $de34aeb5c04427ee$var$cloneNode(from, to) {
    $de34aeb5c04427ee$var$interceptors.forEach((i)=>i(from, to));
    $de34aeb5c04427ee$var$isCloning = true;
    $de34aeb5c04427ee$var$dontRegisterReactiveSideEffects(()=>{
        $de34aeb5c04427ee$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $de34aeb5c04427ee$var$isCloning = false;
}
var $de34aeb5c04427ee$var$isCloningLegacy = false;
function $de34aeb5c04427ee$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $de34aeb5c04427ee$var$isCloning = true;
    $de34aeb5c04427ee$var$isCloningLegacy = true;
    $de34aeb5c04427ee$var$dontRegisterReactiveSideEffects(()=>{
        $de34aeb5c04427ee$var$cloneTree(newEl);
    });
    $de34aeb5c04427ee$var$isCloning = false;
    $de34aeb5c04427ee$var$isCloningLegacy = false;
}
function $de34aeb5c04427ee$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $de34aeb5c04427ee$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $de34aeb5c04427ee$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $de34aeb5c04427ee$var$initTree(el, shallowWalker);
}
function $de34aeb5c04427ee$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $de34aeb5c04427ee$var$effect;
    $de34aeb5c04427ee$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $de34aeb5c04427ee$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $de34aeb5c04427ee$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $de34aeb5c04427ee$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $de34aeb5c04427ee$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $de34aeb5c04427ee$var$camelCase(name) : name;
    switch(name){
        case "value":
            $de34aeb5c04427ee$var$bindInputValue(el, value);
            break;
        case "style":
            $de34aeb5c04427ee$var$bindStyles(el, value);
            break;
        case "class":
            $de34aeb5c04427ee$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $de34aeb5c04427ee$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $de34aeb5c04427ee$var$bindAttribute(el, name, value);
            break;
    }
}
function $de34aeb5c04427ee$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $de34aeb5c04427ee$var$safeParseBoolean(el.value) === value;
            else el.checked = $de34aeb5c04427ee$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$de34aeb5c04427ee$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $de34aeb5c04427ee$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $de34aeb5c04427ee$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $de34aeb5c04427ee$var$setClasses(el, value);
}
function $de34aeb5c04427ee$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $de34aeb5c04427ee$var$setStyles(el, value);
}
function $de34aeb5c04427ee$var$bindAttributeAndProperty(el, name, value) {
    $de34aeb5c04427ee$var$bindAttribute(el, name, value);
    $de34aeb5c04427ee$var$setPropertyIfChanged(el, name, value);
}
function $de34aeb5c04427ee$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $de34aeb5c04427ee$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($de34aeb5c04427ee$var$isBooleanAttr(name)) value = name;
        $de34aeb5c04427ee$var$setIfChanged(el, name, value);
    }
}
function $de34aeb5c04427ee$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $de34aeb5c04427ee$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $de34aeb5c04427ee$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $de34aeb5c04427ee$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $de34aeb5c04427ee$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $de34aeb5c04427ee$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $de34aeb5c04427ee$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $de34aeb5c04427ee$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $de34aeb5c04427ee$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $de34aeb5c04427ee$var$getAttributeBinding(el, name, fallback);
}
function $de34aeb5c04427ee$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $de34aeb5c04427ee$var$dontAutoEvaluateFunctions(()=>{
            return $de34aeb5c04427ee$var$evaluate(el, binding.expression);
        });
    }
    return $de34aeb5c04427ee$var$getAttributeBinding(el, name, fallback);
}
function $de34aeb5c04427ee$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($de34aeb5c04427ee$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $de34aeb5c04427ee$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $de34aeb5c04427ee$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $de34aeb5c04427ee$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $de34aeb5c04427ee$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($de34aeb5c04427ee$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($de34aeb5c04427ee$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($de34aeb5c04427ee$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $de34aeb5c04427ee$var$release(reference);
    };
}
function $de34aeb5c04427ee$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $de34aeb5c04427ee$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($de34aeb5c04427ee$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $de34aeb5c04427ee$var$stores = {};
var $de34aeb5c04427ee$var$isReactive = false;
function $de34aeb5c04427ee$var$store(name, value) {
    if (!$de34aeb5c04427ee$var$isReactive) {
        $de34aeb5c04427ee$var$stores = $de34aeb5c04427ee$var$reactive($de34aeb5c04427ee$var$stores);
        $de34aeb5c04427ee$var$isReactive = true;
    }
    if (value === void 0) return $de34aeb5c04427ee$var$stores[name];
    $de34aeb5c04427ee$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $de34aeb5c04427ee$var$stores[name].init();
    $de34aeb5c04427ee$var$initInterceptors2($de34aeb5c04427ee$var$stores[name]);
}
function $de34aeb5c04427ee$var$getStores() {
    return $de34aeb5c04427ee$var$stores;
}
// packages/alpinejs/src/binds.js
var $de34aeb5c04427ee$var$binds = {};
function $de34aeb5c04427ee$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $de34aeb5c04427ee$var$applyBindingsObject(name, getBindings());
    else $de34aeb5c04427ee$var$binds[name] = getBindings;
    return ()=>{};
}
function $de34aeb5c04427ee$var$injectBindingProviders(obj) {
    Object.entries($de34aeb5c04427ee$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $de34aeb5c04427ee$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $de34aeb5c04427ee$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $de34aeb5c04427ee$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $de34aeb5c04427ee$var$datas = {};
function $de34aeb5c04427ee$var$data(name, callback) {
    $de34aeb5c04427ee$var$datas[name] = callback;
}
function $de34aeb5c04427ee$var$injectDataProviders(obj, context) {
    Object.entries($de34aeb5c04427ee$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $de34aeb5c04427ee$var$Alpine = {
    get reactive () {
        return $de34aeb5c04427ee$var$reactive;
    },
    get release () {
        return $de34aeb5c04427ee$var$release;
    },
    get effect () {
        return $de34aeb5c04427ee$var$effect;
    },
    get raw () {
        return $de34aeb5c04427ee$var$raw;
    },
    version: "3.13.5",
    flushAndStopDeferringMutations: $de34aeb5c04427ee$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $de34aeb5c04427ee$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $de34aeb5c04427ee$var$disableEffectScheduling,
    startObservingMutations: $de34aeb5c04427ee$var$startObservingMutations,
    stopObservingMutations: $de34aeb5c04427ee$var$stopObservingMutations,
    setReactivityEngine: $de34aeb5c04427ee$var$setReactivityEngine,
    onAttributeRemoved: $de34aeb5c04427ee$var$onAttributeRemoved,
    onAttributesAdded: $de34aeb5c04427ee$var$onAttributesAdded,
    closestDataStack: $de34aeb5c04427ee$var$closestDataStack,
    skipDuringClone: $de34aeb5c04427ee$var$skipDuringClone,
    onlyDuringClone: $de34aeb5c04427ee$var$onlyDuringClone,
    addRootSelector: $de34aeb5c04427ee$var$addRootSelector,
    addInitSelector: $de34aeb5c04427ee$var$addInitSelector,
    interceptClone: $de34aeb5c04427ee$var$interceptClone,
    addScopeToNode: $de34aeb5c04427ee$var$addScopeToNode,
    deferMutations: $de34aeb5c04427ee$var$deferMutations,
    mapAttributes: $de34aeb5c04427ee$var$mapAttributes,
    evaluateLater: $de34aeb5c04427ee$var$evaluateLater,
    interceptInit: $de34aeb5c04427ee$var$interceptInit,
    setEvaluator: $de34aeb5c04427ee$var$setEvaluator,
    mergeProxies: $de34aeb5c04427ee$var$mergeProxies,
    extractProp: $de34aeb5c04427ee$var$extractProp,
    findClosest: $de34aeb5c04427ee$var$findClosest,
    onElRemoved: $de34aeb5c04427ee$var$onElRemoved,
    closestRoot: $de34aeb5c04427ee$var$closestRoot,
    destroyTree: $de34aeb5c04427ee$var$destroyTree,
    interceptor: $de34aeb5c04427ee$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $de34aeb5c04427ee$var$transition,
    setStyles: // INTERNAL
    $de34aeb5c04427ee$var$setStyles,
    mutateDom: // INTERNAL
    $de34aeb5c04427ee$var$mutateDom,
    directive: $de34aeb5c04427ee$var$directive,
    entangle: $de34aeb5c04427ee$var$entangle,
    throttle: $de34aeb5c04427ee$var$throttle,
    debounce: $de34aeb5c04427ee$var$debounce,
    evaluate: $de34aeb5c04427ee$var$evaluate,
    initTree: $de34aeb5c04427ee$var$initTree,
    nextTick: $de34aeb5c04427ee$var$nextTick,
    prefixed: $de34aeb5c04427ee$var$prefix,
    prefix: $de34aeb5c04427ee$var$setPrefix,
    plugin: $de34aeb5c04427ee$var$plugin,
    magic: $de34aeb5c04427ee$var$magic,
    store: $de34aeb5c04427ee$var$store,
    start: $de34aeb5c04427ee$var$start,
    clone: $de34aeb5c04427ee$var$clone,
    cloneNode: // INTERNAL
    $de34aeb5c04427ee$var$cloneNode,
    // INTERNAL
    bound: $de34aeb5c04427ee$var$getBinding,
    $data: $de34aeb5c04427ee$var$scope,
    watch: $de34aeb5c04427ee$var$watch,
    walk: $de34aeb5c04427ee$var$walk,
    data: $de34aeb5c04427ee$var$data,
    bind: $de34aeb5c04427ee$var$bind2
};
var $de34aeb5c04427ee$var$alpine_default = $de34aeb5c04427ee$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $de34aeb5c04427ee$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $de34aeb5c04427ee$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $de34aeb5c04427ee$var$isBooleanAttr2 = /* @__PURE__ */ $de34aeb5c04427ee$var$makeMap($de34aeb5c04427ee$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $de34aeb5c04427ee$var$EMPTY_OBJ = Object.freeze({});
var $de34aeb5c04427ee$var$EMPTY_ARR = Object.freeze([]);
var $de34aeb5c04427ee$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $de34aeb5c04427ee$var$hasOwn = (val, key)=>$de34aeb5c04427ee$var$hasOwnProperty.call(val, key);
var $de34aeb5c04427ee$var$isArray = Array.isArray;
var $de34aeb5c04427ee$var$isMap = (val)=>$de34aeb5c04427ee$var$toTypeString(val) === "[object Map]";
var $de34aeb5c04427ee$var$isString = (val)=>typeof val === "string";
var $de34aeb5c04427ee$var$isSymbol = (val)=>typeof val === "symbol";
var $de34aeb5c04427ee$var$isObject = (val)=>val !== null && typeof val === "object";
var $de34aeb5c04427ee$var$objectToString = Object.prototype.toString;
var $de34aeb5c04427ee$var$toTypeString = (value)=>$de34aeb5c04427ee$var$objectToString.call(value);
var $de34aeb5c04427ee$var$toRawType = (value)=>{
    return $de34aeb5c04427ee$var$toTypeString(value).slice(8, -1);
};
var $de34aeb5c04427ee$var$isIntegerKey = (key)=>$de34aeb5c04427ee$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $de34aeb5c04427ee$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $de34aeb5c04427ee$var$camelizeRE = /-(\w)/g;
var $de34aeb5c04427ee$var$camelize = $de34aeb5c04427ee$var$cacheStringFunction((str)=>{
    return str.replace($de34aeb5c04427ee$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $de34aeb5c04427ee$var$hyphenateRE = /\B([A-Z])/g;
var $de34aeb5c04427ee$var$hyphenate = $de34aeb5c04427ee$var$cacheStringFunction((str)=>str.replace($de34aeb5c04427ee$var$hyphenateRE, "-$1").toLowerCase());
var $de34aeb5c04427ee$var$capitalize = $de34aeb5c04427ee$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $de34aeb5c04427ee$var$toHandlerKey = $de34aeb5c04427ee$var$cacheStringFunction((str)=>str ? `on${$de34aeb5c04427ee$var$capitalize(str)}` : ``);
var $de34aeb5c04427ee$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $de34aeb5c04427ee$var$targetMap = /* @__PURE__ */ new WeakMap();
var $de34aeb5c04427ee$var$effectStack = [];
var $de34aeb5c04427ee$var$activeEffect;
var $de34aeb5c04427ee$var$ITERATE_KEY = Symbol("iterate");
var $de34aeb5c04427ee$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $de34aeb5c04427ee$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $de34aeb5c04427ee$var$effect2(fn, options = $de34aeb5c04427ee$var$EMPTY_OBJ) {
    if ($de34aeb5c04427ee$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $de34aeb5c04427ee$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $de34aeb5c04427ee$var$stop(effect3) {
    if (effect3.active) {
        $de34aeb5c04427ee$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $de34aeb5c04427ee$var$uid = 0;
function $de34aeb5c04427ee$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$de34aeb5c04427ee$var$effectStack.includes(effect3)) {
            $de34aeb5c04427ee$var$cleanup(effect3);
            try {
                $de34aeb5c04427ee$var$enableTracking();
                $de34aeb5c04427ee$var$effectStack.push(effect3);
                $de34aeb5c04427ee$var$activeEffect = effect3;
                return fn();
            } finally{
                $de34aeb5c04427ee$var$effectStack.pop();
                $de34aeb5c04427ee$var$resetTracking();
                $de34aeb5c04427ee$var$activeEffect = $de34aeb5c04427ee$var$effectStack[$de34aeb5c04427ee$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $de34aeb5c04427ee$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $de34aeb5c04427ee$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $de34aeb5c04427ee$var$shouldTrack = true;
var $de34aeb5c04427ee$var$trackStack = [];
function $de34aeb5c04427ee$var$pauseTracking() {
    $de34aeb5c04427ee$var$trackStack.push($de34aeb5c04427ee$var$shouldTrack);
    $de34aeb5c04427ee$var$shouldTrack = false;
}
function $de34aeb5c04427ee$var$enableTracking() {
    $de34aeb5c04427ee$var$trackStack.push($de34aeb5c04427ee$var$shouldTrack);
    $de34aeb5c04427ee$var$shouldTrack = true;
}
function $de34aeb5c04427ee$var$resetTracking() {
    const last = $de34aeb5c04427ee$var$trackStack.pop();
    $de34aeb5c04427ee$var$shouldTrack = last === void 0 ? true : last;
}
function $de34aeb5c04427ee$var$track(target, type, key) {
    if (!$de34aeb5c04427ee$var$shouldTrack || $de34aeb5c04427ee$var$activeEffect === void 0) return;
    let depsMap = $de34aeb5c04427ee$var$targetMap.get(target);
    if (!depsMap) $de34aeb5c04427ee$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($de34aeb5c04427ee$var$activeEffect)) {
        dep.add($de34aeb5c04427ee$var$activeEffect);
        $de34aeb5c04427ee$var$activeEffect.deps.push(dep);
        if ($de34aeb5c04427ee$var$activeEffect.options.onTrack) $de34aeb5c04427ee$var$activeEffect.options.onTrack({
            effect: $de34aeb5c04427ee$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $de34aeb5c04427ee$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $de34aeb5c04427ee$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $de34aeb5c04427ee$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $de34aeb5c04427ee$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$de34aeb5c04427ee$var$isArray(target)) {
                    add2(depsMap.get($de34aeb5c04427ee$var$ITERATE_KEY));
                    if ($de34aeb5c04427ee$var$isMap(target)) add2(depsMap.get($de34aeb5c04427ee$var$MAP_KEY_ITERATE_KEY));
                } else if ($de34aeb5c04427ee$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$de34aeb5c04427ee$var$isArray(target)) {
                    add2(depsMap.get($de34aeb5c04427ee$var$ITERATE_KEY));
                    if ($de34aeb5c04427ee$var$isMap(target)) add2(depsMap.get($de34aeb5c04427ee$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($de34aeb5c04427ee$var$isMap(target)) add2(depsMap.get($de34aeb5c04427ee$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $de34aeb5c04427ee$var$isNonTrackableKeys = /* @__PURE__ */ $de34aeb5c04427ee$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $de34aeb5c04427ee$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($de34aeb5c04427ee$var$isSymbol));
var $de34aeb5c04427ee$var$get2 = /* @__PURE__ */ $de34aeb5c04427ee$var$createGetter();
var $de34aeb5c04427ee$var$readonlyGet = /* @__PURE__ */ $de34aeb5c04427ee$var$createGetter(true);
var $de34aeb5c04427ee$var$arrayInstrumentations = /* @__PURE__ */ $de34aeb5c04427ee$var$createArrayInstrumentations();
function $de34aeb5c04427ee$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $de34aeb5c04427ee$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$de34aeb5c04427ee$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($de34aeb5c04427ee$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $de34aeb5c04427ee$var$pauseTracking();
            const res = $de34aeb5c04427ee$var$toRaw(this)[key].apply(this, args);
            $de34aeb5c04427ee$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $de34aeb5c04427ee$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $de34aeb5c04427ee$var$shallowReadonlyMap : $de34aeb5c04427ee$var$readonlyMap : shallow ? $de34aeb5c04427ee$var$shallowReactiveMap : $de34aeb5c04427ee$var$reactiveMap).get(target)) return target;
        const targetIsArray = $de34aeb5c04427ee$var$isArray(target);
        if (!isReadonly && targetIsArray && $de34aeb5c04427ee$var$hasOwn($de34aeb5c04427ee$var$arrayInstrumentations, key)) return Reflect.get($de34aeb5c04427ee$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($de34aeb5c04427ee$var$isSymbol(key) ? $de34aeb5c04427ee$var$builtInSymbols.has(key) : $de34aeb5c04427ee$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $de34aeb5c04427ee$var$track(target, "get", key);
        if (shallow) return res;
        if ($de34aeb5c04427ee$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$de34aeb5c04427ee$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($de34aeb5c04427ee$var$isObject(res)) return isReadonly ? $de34aeb5c04427ee$var$readonly(res) : $de34aeb5c04427ee$var$reactive2(res);
        return res;
    };
}
var $de34aeb5c04427ee$var$set2 = /* @__PURE__ */ $de34aeb5c04427ee$var$createSetter();
function $de34aeb5c04427ee$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $de34aeb5c04427ee$var$toRaw(value);
            oldValue = $de34aeb5c04427ee$var$toRaw(oldValue);
            if (!$de34aeb5c04427ee$var$isArray(target) && $de34aeb5c04427ee$var$isRef(oldValue) && !$de34aeb5c04427ee$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $de34aeb5c04427ee$var$isArray(target) && $de34aeb5c04427ee$var$isIntegerKey(key) ? Number(key) < target.length : $de34aeb5c04427ee$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $de34aeb5c04427ee$var$toRaw(receiver)) {
            if (!hadKey) $de34aeb5c04427ee$var$trigger(target, "add", key, value);
            else if ($de34aeb5c04427ee$var$hasChanged(value, oldValue)) $de34aeb5c04427ee$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $de34aeb5c04427ee$var$deleteProperty(target, key) {
    const hadKey = $de34aeb5c04427ee$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $de34aeb5c04427ee$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $de34aeb5c04427ee$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$de34aeb5c04427ee$var$isSymbol(key) || !$de34aeb5c04427ee$var$builtInSymbols.has(key)) $de34aeb5c04427ee$var$track(target, "has", key);
    return result;
}
function $de34aeb5c04427ee$var$ownKeys(target) {
    $de34aeb5c04427ee$var$track(target, "iterate", $de34aeb5c04427ee$var$isArray(target) ? "length" : $de34aeb5c04427ee$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $de34aeb5c04427ee$var$mutableHandlers = {
    get: $de34aeb5c04427ee$var$get2,
    set: $de34aeb5c04427ee$var$set2,
    deleteProperty: $de34aeb5c04427ee$var$deleteProperty,
    has: $de34aeb5c04427ee$var$has,
    ownKeys: $de34aeb5c04427ee$var$ownKeys
};
var $de34aeb5c04427ee$var$readonlyHandlers = {
    get: $de34aeb5c04427ee$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $de34aeb5c04427ee$var$toReactive = (value)=>$de34aeb5c04427ee$var$isObject(value) ? $de34aeb5c04427ee$var$reactive2(value) : value;
var $de34aeb5c04427ee$var$toReadonly = (value)=>$de34aeb5c04427ee$var$isObject(value) ? $de34aeb5c04427ee$var$readonly(value) : value;
var $de34aeb5c04427ee$var$toShallow = (value)=>value;
var $de34aeb5c04427ee$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $de34aeb5c04427ee$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $de34aeb5c04427ee$var$toRaw(target);
    const rawKey = $de34aeb5c04427ee$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "get", key);
    !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $de34aeb5c04427ee$var$getProto(rawTarget);
    const wrap = isShallow ? $de34aeb5c04427ee$var$toShallow : isReadonly ? $de34aeb5c04427ee$var$toReadonly : $de34aeb5c04427ee$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $de34aeb5c04427ee$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $de34aeb5c04427ee$var$toRaw(target);
    const rawKey = $de34aeb5c04427ee$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "has", key);
    !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $de34aeb5c04427ee$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $de34aeb5c04427ee$var$track($de34aeb5c04427ee$var$toRaw(target), "iterate", $de34aeb5c04427ee$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $de34aeb5c04427ee$var$add(value) {
    value = $de34aeb5c04427ee$var$toRaw(value);
    const target = $de34aeb5c04427ee$var$toRaw(this);
    const proto = $de34aeb5c04427ee$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $de34aeb5c04427ee$var$trigger(target, "add", value, value);
    }
    return this;
}
function $de34aeb5c04427ee$var$set$1(key, value) {
    value = $de34aeb5c04427ee$var$toRaw(value);
    const target = $de34aeb5c04427ee$var$toRaw(this);
    const { has: has2, get: get3 } = $de34aeb5c04427ee$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $de34aeb5c04427ee$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $de34aeb5c04427ee$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $de34aeb5c04427ee$var$trigger(target, "add", key, value);
    else if ($de34aeb5c04427ee$var$hasChanged(value, oldValue)) $de34aeb5c04427ee$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $de34aeb5c04427ee$var$deleteEntry(key) {
    const target = $de34aeb5c04427ee$var$toRaw(this);
    const { has: has2, get: get3 } = $de34aeb5c04427ee$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $de34aeb5c04427ee$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $de34aeb5c04427ee$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $de34aeb5c04427ee$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $de34aeb5c04427ee$var$clear() {
    const target = $de34aeb5c04427ee$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $de34aeb5c04427ee$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $de34aeb5c04427ee$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $de34aeb5c04427ee$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $de34aeb5c04427ee$var$toRaw(target);
        const wrap = isShallow ? $de34aeb5c04427ee$var$toShallow : isReadonly ? $de34aeb5c04427ee$var$toReadonly : $de34aeb5c04427ee$var$toReactive;
        !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "iterate", $de34aeb5c04427ee$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $de34aeb5c04427ee$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $de34aeb5c04427ee$var$toRaw(target);
        const targetIsMap = $de34aeb5c04427ee$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $de34aeb5c04427ee$var$toShallow : isReadonly ? $de34aeb5c04427ee$var$toReadonly : $de34aeb5c04427ee$var$toReactive;
        !isReadonly && $de34aeb5c04427ee$var$track(rawTarget, "iterate", isKeyOnly ? $de34aeb5c04427ee$var$MAP_KEY_ITERATE_KEY : $de34aeb5c04427ee$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $de34aeb5c04427ee$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$de34aeb5c04427ee$var$capitalize(type)} operation ${key}failed: target is readonly.`, $de34aeb5c04427ee$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $de34aeb5c04427ee$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $de34aeb5c04427ee$var$get$1(this, key);
        },
        get size () {
            return $de34aeb5c04427ee$var$size(this);
        },
        has: $de34aeb5c04427ee$var$has$1,
        add: $de34aeb5c04427ee$var$add,
        set: $de34aeb5c04427ee$var$set$1,
        delete: $de34aeb5c04427ee$var$deleteEntry,
        clear: $de34aeb5c04427ee$var$clear,
        forEach: $de34aeb5c04427ee$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $de34aeb5c04427ee$var$get$1(this, key, false, true);
        },
        get size () {
            return $de34aeb5c04427ee$var$size(this);
        },
        has: $de34aeb5c04427ee$var$has$1,
        add: $de34aeb5c04427ee$var$add,
        set: $de34aeb5c04427ee$var$set$1,
        delete: $de34aeb5c04427ee$var$deleteEntry,
        clear: $de34aeb5c04427ee$var$clear,
        forEach: $de34aeb5c04427ee$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $de34aeb5c04427ee$var$get$1(this, key, true);
        },
        get size () {
            return $de34aeb5c04427ee$var$size(this, true);
        },
        has (key) {
            return $de34aeb5c04427ee$var$has$1.call(this, key, true);
        },
        add: $de34aeb5c04427ee$var$createReadonlyMethod("add"),
        set: $de34aeb5c04427ee$var$createReadonlyMethod("set"),
        delete: $de34aeb5c04427ee$var$createReadonlyMethod("delete"),
        clear: $de34aeb5c04427ee$var$createReadonlyMethod("clear"),
        forEach: $de34aeb5c04427ee$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $de34aeb5c04427ee$var$get$1(this, key, true, true);
        },
        get size () {
            return $de34aeb5c04427ee$var$size(this, true);
        },
        has (key) {
            return $de34aeb5c04427ee$var$has$1.call(this, key, true);
        },
        add: $de34aeb5c04427ee$var$createReadonlyMethod("add"),
        set: $de34aeb5c04427ee$var$createReadonlyMethod("set"),
        delete: $de34aeb5c04427ee$var$createReadonlyMethod("delete"),
        clear: $de34aeb5c04427ee$var$createReadonlyMethod("clear"),
        forEach: $de34aeb5c04427ee$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $de34aeb5c04427ee$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $de34aeb5c04427ee$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $de34aeb5c04427ee$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $de34aeb5c04427ee$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$de34aeb5c04427ee$var$mutableInstrumentations, $de34aeb5c04427ee$var$readonlyInstrumentations, $de34aeb5c04427ee$var$shallowInstrumentations, $de34aeb5c04427ee$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $de34aeb5c04427ee$var$createInstrumentations();
function $de34aeb5c04427ee$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $de34aeb5c04427ee$var$shallowReadonlyInstrumentations : $de34aeb5c04427ee$var$shallowInstrumentations : isReadonly ? $de34aeb5c04427ee$var$readonlyInstrumentations : $de34aeb5c04427ee$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($de34aeb5c04427ee$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $de34aeb5c04427ee$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $de34aeb5c04427ee$var$createInstrumentationGetter(false, false)
};
var $de34aeb5c04427ee$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $de34aeb5c04427ee$var$createInstrumentationGetter(true, false)
};
function $de34aeb5c04427ee$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $de34aeb5c04427ee$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $de34aeb5c04427ee$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $de34aeb5c04427ee$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $de34aeb5c04427ee$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $de34aeb5c04427ee$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $de34aeb5c04427ee$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $de34aeb5c04427ee$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $de34aeb5c04427ee$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $de34aeb5c04427ee$var$targetTypeMap($de34aeb5c04427ee$var$toRawType(value));
}
function $de34aeb5c04427ee$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $de34aeb5c04427ee$var$createReactiveObject(target, false, $de34aeb5c04427ee$var$mutableHandlers, $de34aeb5c04427ee$var$mutableCollectionHandlers, $de34aeb5c04427ee$var$reactiveMap);
}
function $de34aeb5c04427ee$var$readonly(target) {
    return $de34aeb5c04427ee$var$createReactiveObject(target, true, $de34aeb5c04427ee$var$readonlyHandlers, $de34aeb5c04427ee$var$readonlyCollectionHandlers, $de34aeb5c04427ee$var$readonlyMap);
}
function $de34aeb5c04427ee$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$de34aeb5c04427ee$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $de34aeb5c04427ee$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $de34aeb5c04427ee$var$toRaw(observed) {
    return observed && $de34aeb5c04427ee$var$toRaw(observed["__v_raw"]) || observed;
}
function $de34aeb5c04427ee$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$de34aeb5c04427ee$var$magic("nextTick", ()=>$de34aeb5c04427ee$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$de34aeb5c04427ee$var$magic("dispatch", (el)=>$de34aeb5c04427ee$var$dispatch.bind($de34aeb5c04427ee$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$de34aeb5c04427ee$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $de34aeb5c04427ee$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$de34aeb5c04427ee$var$magic("store", $de34aeb5c04427ee$var$getStores);
// packages/alpinejs/src/magics/$data.js
$de34aeb5c04427ee$var$magic("data", (el)=>$de34aeb5c04427ee$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$de34aeb5c04427ee$var$magic("root", (el)=>$de34aeb5c04427ee$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$de34aeb5c04427ee$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $de34aeb5c04427ee$var$mergeProxies($de34aeb5c04427ee$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $de34aeb5c04427ee$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $de34aeb5c04427ee$var$globalIdMemo = {};
function $de34aeb5c04427ee$var$findAndIncrementId(name) {
    if (!$de34aeb5c04427ee$var$globalIdMemo[name]) $de34aeb5c04427ee$var$globalIdMemo[name] = 0;
    return ++$de34aeb5c04427ee$var$globalIdMemo[name];
}
function $de34aeb5c04427ee$var$closestIdRoot(el, name) {
    return $de34aeb5c04427ee$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $de34aeb5c04427ee$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $de34aeb5c04427ee$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$de34aeb5c04427ee$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $de34aeb5c04427ee$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $de34aeb5c04427ee$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $de34aeb5c04427ee$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$de34aeb5c04427ee$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $de34aeb5c04427ee$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$de34aeb5c04427ee$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$de34aeb5c04427ee$var$warnMissingPluginMagic("Focus", "focus", "focus");
$de34aeb5c04427ee$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $de34aeb5c04427ee$var$warnMissingPluginMagic(name, magicName, slug) {
    $de34aeb5c04427ee$var$magic(magicName, (el)=>$de34aeb5c04427ee$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$de34aeb5c04427ee$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $de34aeb5c04427ee$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$de34aeb5c04427ee$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $de34aeb5c04427ee$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $de34aeb5c04427ee$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $de34aeb5c04427ee$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $de34aeb5c04427ee$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $de34aeb5c04427ee$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $de34aeb5c04427ee$var$getTarget(expression);
        $de34aeb5c04427ee$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $de34aeb5c04427ee$var$teleportContainerDuringClone = document.createElement("div");
function $de34aeb5c04427ee$var$getTarget(expression) {
    let target = $de34aeb5c04427ee$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $de34aeb5c04427ee$var$teleportContainerDuringClone;
    })();
    if (!target) $de34aeb5c04427ee$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $de34aeb5c04427ee$var$handler = ()=>{};
$de34aeb5c04427ee$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$de34aeb5c04427ee$var$directive("ignore", $de34aeb5c04427ee$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$de34aeb5c04427ee$var$directive("effect", $de34aeb5c04427ee$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($de34aeb5c04427ee$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $de34aeb5c04427ee$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $de34aeb5c04427ee$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $de34aeb5c04427ee$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $de34aeb5c04427ee$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $de34aeb5c04427ee$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $de34aeb5c04427ee$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $de34aeb5c04427ee$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($de34aeb5c04427ee$var$isKeyEvent(event)) {
            if ($de34aeb5c04427ee$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $de34aeb5c04427ee$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $de34aeb5c04427ee$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $de34aeb5c04427ee$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $de34aeb5c04427ee$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $de34aeb5c04427ee$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $de34aeb5c04427ee$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $de34aeb5c04427ee$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $de34aeb5c04427ee$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $de34aeb5c04427ee$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($de34aeb5c04427ee$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $de34aeb5c04427ee$var$keyToModifiers(key) {
    if (!key) return [];
    key = $de34aeb5c04427ee$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$de34aeb5c04427ee$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $de34aeb5c04427ee$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $de34aeb5c04427ee$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $de34aeb5c04427ee$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $de34aeb5c04427ee$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($de34aeb5c04427ee$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $de34aeb5c04427ee$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $de34aeb5c04427ee$var$isCloning ? ()=>{} : $de34aeb5c04427ee$var$on(el, event, modifiers, (e)=>{
        setValue($de34aeb5c04427ee$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $de34aeb5c04427ee$var$on(el.form, "reset", [], (e)=>{
            $de34aeb5c04427ee$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $de34aeb5c04427ee$var$mutateDom(()=>$de34aeb5c04427ee$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $de34aeb5c04427ee$var$getInputValue(el, modifiers, event, currentValue) {
    return $de34aeb5c04427ee$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $de34aeb5c04427ee$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $de34aeb5c04427ee$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$de34aeb5c04427ee$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $de34aeb5c04427ee$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $de34aeb5c04427ee$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $de34aeb5c04427ee$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $de34aeb5c04427ee$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $de34aeb5c04427ee$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $de34aeb5c04427ee$var$isNumeric2(number) ? number : rawValue;
}
function $de34aeb5c04427ee$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $de34aeb5c04427ee$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $de34aeb5c04427ee$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$de34aeb5c04427ee$var$directive("cloak", (el)=>queueMicrotask(()=>$de34aeb5c04427ee$var$mutateDom(()=>el.removeAttribute($de34aeb5c04427ee$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$de34aeb5c04427ee$var$addInitSelector(()=>`[${$de34aeb5c04427ee$var$prefix("init")}]`);
$de34aeb5c04427ee$var$directive("init", $de34aeb5c04427ee$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$de34aeb5c04427ee$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $de34aeb5c04427ee$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$de34aeb5c04427ee$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $de34aeb5c04427ee$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $de34aeb5c04427ee$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$de34aeb5c04427ee$var$mapAttributes($de34aeb5c04427ee$var$startingWith(":", $de34aeb5c04427ee$var$into($de34aeb5c04427ee$var$prefix("bind:"))));
var $de34aeb5c04427ee$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $de34aeb5c04427ee$var$injectBindingProviders(bindingProviders);
        let getBindings = $de34aeb5c04427ee$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $de34aeb5c04427ee$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $de34aeb5c04427ee$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $de34aeb5c04427ee$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $de34aeb5c04427ee$var$mutateDom(()=>$de34aeb5c04427ee$var$bind(el, value, result, modifiers));
        }));
};
$de34aeb5c04427ee$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$de34aeb5c04427ee$var$directive("bind", $de34aeb5c04427ee$var$handler2);
function $de34aeb5c04427ee$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$de34aeb5c04427ee$var$addRootSelector(()=>`[${$de34aeb5c04427ee$var$prefix("data")}]`);
$de34aeb5c04427ee$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($de34aeb5c04427ee$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $de34aeb5c04427ee$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $de34aeb5c04427ee$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $de34aeb5c04427ee$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $de34aeb5c04427ee$var$injectMagics(data2, el);
    let reactiveData = $de34aeb5c04427ee$var$reactive(data2);
    $de34aeb5c04427ee$var$initInterceptors2(reactiveData);
    let undo = $de34aeb5c04427ee$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $de34aeb5c04427ee$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $de34aeb5c04427ee$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$de34aeb5c04427ee$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $de34aeb5c04427ee$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$de34aeb5c04427ee$var$isCloning) return false;
    if ($de34aeb5c04427ee$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$de34aeb5c04427ee$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $de34aeb5c04427ee$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $de34aeb5c04427ee$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $de34aeb5c04427ee$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $de34aeb5c04427ee$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$de34aeb5c04427ee$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $de34aeb5c04427ee$var$parseForExpression(expression);
    let evaluateItems = $de34aeb5c04427ee$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $de34aeb5c04427ee$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$de34aeb5c04427ee$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $de34aeb5c04427ee$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($de34aeb5c04427ee$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $de34aeb5c04427ee$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $de34aeb5c04427ee$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($de34aeb5c04427ee$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $de34aeb5c04427ee$var$mutateDom(()=>{
                if (!elForSpot) $de34aeb5c04427ee$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $de34aeb5c04427ee$var$reactive(scope2);
            $de34aeb5c04427ee$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $de34aeb5c04427ee$var$mutateDom(()=>{
                lastEl.after(clone2);
                $de34aeb5c04427ee$var$initTree(clone2);
            });
            if (typeof key === "object") $de34aeb5c04427ee$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $de34aeb5c04427ee$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $de34aeb5c04427ee$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $de34aeb5c04427ee$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $de34aeb5c04427ee$var$handler3() {}
$de34aeb5c04427ee$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $de34aeb5c04427ee$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$de34aeb5c04427ee$var$directive("ref", $de34aeb5c04427ee$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$de34aeb5c04427ee$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $de34aeb5c04427ee$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $de34aeb5c04427ee$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $de34aeb5c04427ee$var$addScopeToNode(clone2, {}, el);
        $de34aeb5c04427ee$var$mutateDom(()=>{
            el.after(clone2);
            $de34aeb5c04427ee$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $de34aeb5c04427ee$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($de34aeb5c04427ee$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$de34aeb5c04427ee$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$de34aeb5c04427ee$var$setIdRoot(el, name));
});
$de34aeb5c04427ee$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$de34aeb5c04427ee$var$mapAttributes($de34aeb5c04427ee$var$startingWith("@", $de34aeb5c04427ee$var$into($de34aeb5c04427ee$var$prefix("on:"))));
$de34aeb5c04427ee$var$directive("on", $de34aeb5c04427ee$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $de34aeb5c04427ee$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $de34aeb5c04427ee$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$de34aeb5c04427ee$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$de34aeb5c04427ee$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$de34aeb5c04427ee$var$warnMissingPluginDirective("Focus", "trap", "focus");
$de34aeb5c04427ee$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $de34aeb5c04427ee$var$warnMissingPluginDirective(name, directiveName, slug) {
    $de34aeb5c04427ee$var$directive(directiveName, (el)=>$de34aeb5c04427ee$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$de34aeb5c04427ee$var$alpine_default.setEvaluator($de34aeb5c04427ee$var$normalEvaluator);
$de34aeb5c04427ee$var$alpine_default.setReactivityEngine({
    reactive: $de34aeb5c04427ee$var$reactive2,
    effect: $de34aeb5c04427ee$var$effect2,
    release: $de34aeb5c04427ee$var$stop,
    raw: $de34aeb5c04427ee$var$toRaw
});
var $de34aeb5c04427ee$export$b7ee041e4ad2afec = $de34aeb5c04427ee$var$alpine_default;
// packages/alpinejs/builds/module.js
var $de34aeb5c04427ee$export$2e2bcd8739ae039 = $de34aeb5c04427ee$export$b7ee041e4ad2afec;

});

parcelRegister("g5lMs", function(module, exports) {


module.exports = (parcelRequire("dA1sy"))((parcelRequire("kb7iW")).resolve("ittYd")).then(()=>parcelRequire("79hug"));

});
parcelRegister("dA1sy", function(module, exports) {
"use strict";

var $8if87 = parcelRequire("8if87");
module.exports = $8if87(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("8if87", function(module, exports) {
"use strict";
var $609bbdabeaa083b1$var$cachedBundles = {};
var $609bbdabeaa083b1$var$cachedPreloads = {};
var $609bbdabeaa083b1$var$cachedPrefetches = {};
function $609bbdabeaa083b1$var$getCache(type) {
    switch(type){
        case "preload":
            return $609bbdabeaa083b1$var$cachedPreloads;
        case "prefetch":
            return $609bbdabeaa083b1$var$cachedPrefetches;
        default:
            return $609bbdabeaa083b1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $609bbdabeaa083b1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $j4NmD = parcelRequire("j4NmD");
// packages/persist/src/index.js
function $6db105834249d544$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $6db105834249d544$var$storageHas(lookup, storage) ? $6db105834249d544$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $6db105834249d544$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $6db105834249d544$var$storageHas(key, storage) ? $6db105834249d544$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $6db105834249d544$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $6db105834249d544$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $6db105834249d544$var$storageGet(key, storage) {
    return JSON.parse(storage.getItem(key, storage));
}
function $6db105834249d544$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $6db105834249d544$export$2e2bcd8739ae039 = $6db105834249d544$export$9a6132153fba2e0;


(0, $j4NmD.default).plugin((0, $6db105834249d544$export$2e2bcd8739ae039));
window.Alpine = (0, $j4NmD.default);
(0, $j4NmD.default).store("settingsModal", {
    show: false,
    developmentMode: false,
    enableDevTools: (0, $j4NmD.default).$persist(false).as("enableDevTools"),
    requireAllHintsUsed: (0, $j4NmD.default).$persist(false).as("requireAllHintsUsed")
});

// must come after the settings modal store (because I can't figure out how to make typescript play nice with $persist)
(parcelRequire("g5lMs")).then(()=>{
    (0, $j4NmD.default).start();
});

})();
//# sourceMappingURL=index.b574b2e9.js.map
